import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DepotComponent } from './depot/depot.component';
import { RetraitComponent } from './retrait/retrait.component';
import { NouveaupartenaireComponent } from './nouveaupartenaire/nouveaupartenaire.component';
import { FirstLoginActivationComponent } from './first-login-activation/first-login-activation.component';
import { RoleGuardService } from '../service/security/role-guard.service';

const MICROFINANCE_ROLES = [
  'MICROFINANCE',
  'MICROFINANCE_SUPERVISOR',
  'MICROFINANCE_CAISSE',
  'MICROFINANCE_COLLECTE',
  'MICROFINANCE_CREDIT'
];

const routes: Routes = [
  {
    path: 'utilisateur/partenaire/activation',
    component: FirstLoginActivationComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: MICROFINANCE_ROLES, allowUnactivated: true }
  },
  {
    path: 'utilisateur/partenaire/dashboard',
    component: DashboardComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: MICROFINANCE_ROLES }
  },
  {
    path: 'utilisateur/partenaire/depot',
    component: DepotComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: MICROFINANCE_ROLES }
  },
  {
    path: 'utilisateur/partenaire/retrait',
    component: RetraitComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: MICROFINANCE_ROLES }
  },
  {
    path: 'utilisateur/partenaire/ajouter/employer',
    component: NouveaupartenaireComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: MICROFINANCE_ROLES }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartenaireRoutingModule { }
